import { Slider } from '@sparkpost/matchbox';

/**
 * Matchbox Slider component.
 * @see https://design.sparkpost.com/components/slider/
 */
const MatchboxSlider = Slider;

export default MatchboxSlider;
